var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIconsBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_104",
    "data-name": "Group 104",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.799,
    height: 38.779,
    viewBox: "0 0 40.799 38.779",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M40.114,29.9,21.809,13.225a2.083,2.083,0,0,0-2.818,0L.685,29.9a2.092,2.092,0,0,0,1.409,3.639H5.018V50.255a1.2,1.2,0,0,0,1.2,1.2H16.251a1.2,1.2,0,0,0,1.2-1.2V40.108h5.9V50.255a1.2,1.2,0,0,0,1.2,1.2H34.581a1.2,1.2,0,0,0,1.2-1.2V33.543h2.924A2.092,2.092,0,0,0,40.114,29.9Z",
    transform: "translate(0 -12.675)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconsBlack);
export default __webpack_public_path__ + "static/media/home_iconsBlack.144f76b36e4037ef1938d380ff47b969.svg";
export { ForwardRef as ReactComponent };